import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminEditUser from "../../Components/Admin/AdminEditUser";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditUserPage = () => {
  return (

    <AdminEditUser />

  );
};

export default AdminEditUserPage;
